<template>

<div>

	<div v-if="type == 'rule_has_payment_account' && extraData == 1">
		Massören har inte självfakturering
	</div>

	<div v-else>

		<div v-if="type == 'rule_has_prices_internal' || type == 'rule_has_prices_external' || type == 'rule_has_prices_pt'">

			<div v-for="payment in payments">
				{{ payment.duration.minutes }} minuter {{ payment.price }} kr
			</div>

		</div>

		<p v-if="is_valid == true">Finns ifyllt</p>
		<p v-if="is_valid == false"></p>

	</div>

</div>

</template>

<script>
export default {
    props: {
	        type: {},
	        currentData: {},
	        rule: {},
	        extraData: null
	    },
	    computed: {

	    	is_valid: function () {
	    		if (this.type != 'rule_has_prices_internal' && this.type != 'rule_has_prices_external' && this.type != 'rule_has_prices_pt') {
	    			return this.rule
	    		}
	    	},

	    	payments: function () {
	    		const self = this

	    		if (self.extraData != null && self.extraData[0]) {
	    			if (self.type == 'rule_has_prices_internal') {
	    				var account_id = 1
	    			}
	    			if (self.type == 'rule_has_prices_external') {
	    				var account_id = 2
	    			}
	    			if (self.type == 'rule_has_prices_pt') {
	    				var account_id = 4
	    			}

	    			console.log('check rule')
	    			console.log(self.extraData[0].prices[1])

		    		const results = self.extraData[0].prices[account_id].filter(function (el) {
			          return el.account_id == account_id && el.price > 0
			        })

		    		return results
			    }

			    return null
	    	}

	    }

}
</script>
